export default __webpack_public_path__ + "static/Fredrik_Lo_fbergs-4a73b83e4eb5dfbaad9f7bfefbbf3742.webp";